import createTestId, { getTestId } from "../../../../fabrics/createTestId";

const HEADER_CLOSE_PREFIX = "header-close";

export const HEADER_CLOSE_TEST_ID = getTestId(HEADER_CLOSE_PREFIX);

export const createTestIdForHeaderClose = createTestId(HEADER_CLOSE_PREFIX);
